import React, {useState, createContext, useEffect} from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import Login from './Components/Login';
import Admin from './Components/Admin';
import Order from './Components/Order';
import Products from './Components/Products';
import Update from './Components/Update';
import Error from './Components/Error';
import Spinner from './Components/Spinner';
import PrivateRoute from './Components/PrivateRoute';
import { db } from './Components/Firebase';
import './App.css';
export const UserContext = createContext();

function App() {
  const [user, setUser] = useState({});
  const [logo, setLogo] = useState({});
  const [cover, setCover] = useState({});
  const [allItems, setAllItems] = useState([]);

  // fetching Logo
  useEffect(() => {
    db.collection('logo').onSnapshot(snapshot => {
      const logoData = snapshot.docs.map(doc => doc.data());
      setLogo(logoData[0]);
  })}, []);
  
  // fetching cover photo
  useEffect(() => {
    db.collection('cover').onSnapshot(snapshot => {
      const coverPhoto = snapshot.docs.map(doc => doc.data());
      setCover(coverPhoto[0]);
  })}, []);

  // fetching all items
  useEffect(() => {
    db.collection('items')
    .onSnapshot(snapshot => {
      const itemsArray = snapshot.docs.map(doc => {
        return { id: doc.id, data : doc.data() };                
      });
      setAllItems(itemsArray.reverse());
  })}, []);

  
  return (
    <UserContext.Provider value={[user, setUser]}>
      {
        cover.url ? 
        <Router>
          <Navbar logo={logo} />        
          <Switch>
            <Route path="/" exact>
              <Home cover={cover} allItems={allItems} />
            </Route>
            <Route path="/order" component={Order} />
            <Route path="/login" component={Login} />
            <Route path="/products">
              <Products allItems={allItems} />
            </Route>
            <PrivateRoute path="/admin">
              <Admin />
            </PrivateRoute>
            <PrivateRoute path="/update">
              <Update allItems={allItems} />
            </PrivateRoute>
            <Route path="*" component={Error} />
          </Switch>
        </Router> :
        <Spinner />
      }
    </UserContext.Provider>
  );
}

export default App;